import {gql} from '@apollo/client'
import {Flow, FlowGenerator, UseFlowQuery} from 'features/procedures/Flow/Flow'
import {maybeYieldChildcareMethodSelect} from 'features/procedures/Flow/helpers'
import {useQuery} from 'hooks/graphql'

const ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE_FLOW_QUERY = gql`
  query AdditionalChildcareLeaveAllowanceFlowQuery($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        employee {
          id
          employmentInsurance {
            id
            joined
          }
          pastChildcareProcedureStatuses(forProcedureType: additional_childcare_leave_allowance) {
            id
          }
        }
        childcareMethodSelect: procedureTmpDatum(type: draft, name: "childcare_method_select") {
          id
        }
      }
    }
  }
`

interface FlowQueryData {
  client: {
    id: string
    procedureStatus: {
      id: string
      employee: {
        id: string
        employmentInsurance?: {
          id: string
          joined: boolean
        }
        pastChildcareProcedureStatuses: {id: string}[]
      }
      childcareMethodSelect?: {
        id: string
      }
    }
  }
}

const useFlowQuery: UseFlowQuery<FlowQueryData> = ({procedureStatusId}) => {
  return useQuery<FlowQueryData>(ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE_FLOW_QUERY, {
    variables: {procedureStatusId},
    fetchPolicy: 'network-only',
  })
}

const makeFlow: FlowGenerator<FlowQueryData> = function* (data, _flowStatus, flowMode) {
  const procedureStatus = data.client.procedureStatus
  const employee = procedureStatus.employee
  const employmentInsuranceJoined = employee.employmentInsurance?.joined

  yield* maybeYieldChildcareMethodSelect({
    flowMode,
    pastChildcareCount: employee.pastChildcareProcedureStatuses.length,
    methodSelectExists: !!procedureStatus.childcareMethodSelect,
  })

  if (employmentInsuranceJoined) {
    yield 'R511'
  }

  yield 'Attachments'
}

export const AdditionalChildcareLeaveAllowanceFlow = () => (
  <Flow procedureContext="admin" makeFlow={makeFlow} useFlowQuery={useFlowQuery} />
)
